import { SET_BOARD_CALENDAR_LIST_MODE } from "./boardCalendarUiTypes";

const initialState = {
  /** @type {Record<string, "task"|"sprint"|"roadmap">} */
  listModeByBoard: {},
};

export const boardCalendarUiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOARD_CALENDAR_LIST_MODE: {
      const { boardId, mode } = action.payload || {};
      if (
        !boardId ||
        (mode !== "task" && mode !== "sprint" && mode !== "roadmap")
      )
        return state;
      return {
        ...state,
        listModeByBoard: {
          ...state.listModeByBoard,
          [boardId]: mode,
        },
      };
    }
    default:
      return state;
  }
};
